import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

// Component to translate text automatically
const TranslatedText = ({ children, as: Component = 'span', className = '', ...props }) => {
  const { currentLanguage, translateText } = useLanguage();
  const [translatedContent, setTranslatedContent] = useState(children);

  useEffect(() => {
    let isMounted = true;

    const translate = async () => {
      if (currentLanguage === 'en' || !children || typeof children !== 'string') {
        setTranslatedContent(children);
        return;
      }

      try {
        const translated = await translateText(children, currentLanguage);
        if (isMounted) {
          setTranslatedContent(translated);
        }
      } catch (error) {
        if (isMounted) {
          setTranslatedContent(children);
        }
      }
    };

    translate();

    return () => {
      isMounted = false;
    };
  }, [children, currentLanguage, translateText]);

  return (
    <Component className={className} {...props}>
      {translatedContent}
    </Component>
  );
};

// Shorthand component for common use
export const T = ({ children }) => <TranslatedText>{children}</TranslatedText>;

export default TranslatedText;
